/**
 * Relative Imports
*/

import { User } from './types';

/**
 * Public Functions
*/

export function isUser(object: unknown): object is User
{
  return typeof (object as User).state?.['display-name'] === 'string';
}
